export class CompanyInfo {

    private active: boolean;
    private city: string;
    private companyCif: string;
    private companyName: string;
    private country: string;
    private creationDate: number;
    private email: string;
    private faxNumber: string;
    private fiscalName: string;
    private imageL: string;
    private imageM: string;
    private imageS: string;
    private imageXl: string;
    private internalId: string;
    private modificationDate: number;
    private phoneNumber: string;
    private province: string;
    private region: string;
    private street: string;
    private zipCode: string;

    constructor(active?: boolean,
        city?: string,
        companyCif?: string,
        companyName?: string,
        country?: string,
        creationDate?: number,
        email?: string,
        faxNumber?: string,
        fiscalName?: string,
        imageL?: string,
        imageM?: string,
        imageS?: string,
        imageXl?: string,
        internalId?: string,
        modificationDate?: number,
        phoneNumber?: string,
        province?: string,
        region?: string,
        street?: string,
        zipCode?: string) { }

    public get Active() {
        return this.active;
    }
    public get City() {
        return this.city;
    }
    public get CompanyCif() {
        return this.companyCif;
    }
    public get CompanyName() {
        return this.companyName;
    }
    public get Country() {
        return this.country;
    }
    public get CreationDate() {
        return this.creationDate;
    }
    public get Email() {
        return this.email;
    }
    public get FaxNumber() {
        return this.faxNumber;
    }
    public get FiscalName() {
        return this.fiscalName;
    }
    public get ImageM() {
        return this.imageM;
    }
    public get ImageS() {
        return this.imageS;
    }
    public get ImageL() {
        return this.imageL;
    }
    public get ImageXl() {
        return this.imageXl;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get ModificationDate() {
        return this.modificationDate;
    }
    public get PhoneNumber() {
        return this.phoneNumber;
    }
    public get Province() {
        return this.province;
    }
    public get Region() {
        return this.region;
    }
    public get Street() {
        return this.street;
    }
    public get ZipCode() {
        return this.zipCode;
    }

    public set Active(active) {
        this.active = active;
    }
    public set City(city) {
        this.city = city;
    }
    public set CompanyCif(companyCif) {
        this.companyCif = companyCif;
    }
    public set CompanyName(companyName) {
        this.companyName = companyName;
    }
    public set Country(country) {
        this.country = country;
    }
    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }
    public set Email(email) {
        this.email = email;
    }
    public set FaxNumber(faxNumber) {
        this.faxNumber = faxNumber;
    }
    public set FiscalName(fiscalName) {
        this.fiscalName = fiscalName;
    }
    public set ImageL(imageL) {
        this.imageL = imageL;
    }
    public set ImageM(imageM) {
        this.imageM = imageM;
    }
    public set ImageS(imageS) {
        this.imageS = imageS;
    }
    public set ImageXl(imageXl) {
        this.imageXl = imageXl;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set ModificationDate(modificationDate) {
        this.modificationDate = modificationDate;
    }
    public set PhoneNumber(phoneNumber) {
        this.phoneNumber = phoneNumber;
    }
    public set Province(province) {
        this.province = province;
    }
    public set Region(region) {
        this.region = region;
    }
    public set Street(street) {
        this.street = street;
    }
    public set ZipCode(zipCode) {
        this.zipCode = zipCode;
    }
}
